import React from 'react';

export const LazyUserSettingsHeader = React.lazy(() =>
  import(/* webpackChunkName: "user-settings" */ './UserSettingsHeader'),
);
